module.exports = __webpack_public_path__ + "img/1476176411.605aa333.jpg";